<button class="polaris-button" [ngClass]="'polaris-button--' + variant" type="button" (click)="pressed.emit()">
  <ng-content></ng-content>
</button>
